export default "__VITE_ASSET__D5qvF5GY__"